export const languages = [
    {key: 'en', name: 'English'},
    {key: 'es', name: 'Español'},
    {key: 'de', name: 'Deutsch'},
    {key: 'ja', name: '日本人'},
    {key: 'fr', name: 'Français'},
    {key: 'zh', name: '中文'},
    {key: 'pt', name: 'Português'},
];



// WEBPACK FOOTER //
// ./src/portal/data/constants.js